import { window } from "globalthis/implementation";

import {GetURL} from "./../config";

// const GetURL = 'https://leon-gallery.com';
// const GetURL = 'http://localhost:8081';
//  const GetURL = 'http://157.230.43.47:8081';


export async function homehandle() {

  localStorage.removeItem("@imageSingle");

  const dataSend = {
    title: 'Home Leon Gallery | Premier Philippine Art Gallery & Auction House',
  discription: 'Leon Gallery is Manila’s leading art gallery and auction house specializing in Filipino masterpieces, historical works, and contemporary art. Discover exhibitions and auctions.',
  lotNo: '',
  canonical: `${GetURL}/home`,
  url: `${GetURL}/home`,
  imagUrl: `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
    };

    await fetch(`${GetURL}/meta`, {
      method: "POST",
      body: JSON.stringify(dataSend),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())

      .then((data) => {
        console.log("data send here ", data);
      })
      .catch((error) => {
        // alert.error(error)
        console.log("error ", error);
      });
      window.location.href = "/home?data=home";


}

export function abouthandle() {
  localStorage.removeItem("@imageSingle");

  window.location.href = `/about?data=about us`;


}

export async function upcommingEventsHandle(data) {
  localStorage.removeItem("@imageSingle");
  const dataSend = {
    title: 'Art Auctions at Leon Gallery | Philippine Art & Masterpieces',
    discription: 'Explore upcoming and past art auctions at Leon Gallery. Discover Philippine masterpieces, rare collections, and renowned artists. Join our auctions for exclusive art opportunities.',
    lotNo: '',
    canonical: `${GetURL}/faq`,
    url: `${GetURL}/faq`,
    imagUrl:`${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
  };

  await fetch(`${GetURL}/meta`, {
    method: "POST",
    body: JSON.stringify(dataSend),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())

    .then((data) => {
      console.log("data send here ", data);
    })
    .catch((error) => {
      // alert.error(error)
      console.log("error ", error);
    });

    window.location.href = `/auctions`;

}

export function handleResults(data) {

  return (window.location.href = `/results?data=${data}`);
}

export function handleJewelry(data) {
  //console.log(data)
  if (data === "JEWELRY" || data === "WATCHES") {
    return (window.location.href = `/buy/private-sale/jewelry?data=${data}`);
  } else {
    return (window.location.href = `/buy/jewelry?data=JEWELRY`);
  }
}

export async function handleWatches(data) {
  const dataSend = {
    title: `Private watches Sales - Buy Fine Art | León Gallery Philippines `,
    discription: `Explore private watches sales at León Gallery. Discover and acquire exceptional fine art through our exclusive private sale offerings. Enquire today.`,
    lotNo: '',
    canonical: `${GetURL}/sale?data=PAINTING`,
    url: `${GetURL}/sale?data=PAINTING`,
    imagUrl: `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
  };

  await fetch(`${GetURL}/meta`, {
    method: "POST",
    body: JSON.stringify(dataSend),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())

    .then((data) => {
      console.log("data send here ", data);
    })
    .catch((error) => {
      // alert.error(error)
      console.log("error ", error);
    });
  return (window.location.href = `/buy/watches?data=${data}`);
}

export function handlebags(data) {
  
  return (window.location.href = `/buy/handbags?data=${data}`);
}

export function handleAuctionsRoom() {
  return (window.location.href = `/auctions/room`);
}

export function handleFaq() {
  localStorage.removeItem("imageSingle");
  return (window.location.href = `/faq?data=faq`);
}

// export function handlePrivate(data) {
//   return (window.location.href = `/private-sale/`);
// }

export async function handlePrivatePainting(data) {
  const dataSend = {
    title: `Private Painting Sales - Buy Fine Art | León Gallery Philippines `,
    discription: `Explore private Painting sales at León Gallery. Discover and acquire exceptional fine art through our exclusive private sale offerings. Enquire today.`,
    lotNo: '',
    canonical: `${GetURL}/sale?data=PAINTING`,
    url: `${GetURL}/sale?data=PAINTING`,
    imagUrl: `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
  };

  await fetch(`${GetURL}/meta`, {
    method: "POST",
    body: JSON.stringify(dataSend),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())

    .then((data) => {
      console.log("data send here ", data);
    })
    .catch((error) => {
      // alert.error(error)
      console.log("error ", error);
    });
  return (window.location.href = `/private/sale?data=${data}`);
}

export async function handlePrivateFurniture(data) {
  const dataSend = {
    title: `Private Furniture Sales - Buy Fine Art | León Gallery Philippines `,
    discription: `Explore private Furniture sales at León Gallery. Discover and acquire exceptional fine art through our exclusive private sale offerings. Enquire today.`,
    lotNo: '',
    canonical: `${GetURL}/sale?data=PAINTING`,
    url: `${GetURL}/sale?data=PAINTING`,
    imagUrl: `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
  };

  await fetch(`${GetURL}/meta`, {
    method: "POST",
    body: JSON.stringify(dataSend),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())

    .then((data) => {
      console.log("data send here ", data);
    })
    .catch((error) => {
      // alert.error(error)
      console.log("error ", error);
    });
  return (window.location.href = `/private/sale?data=${data}`);
}

export async function handlePrivateJewelry(data) {

  const dataSend = {
    title: `Private Jewelry Sales - Buy Fine Art | León Gallery Philippines `,
    discription: `Explore private Jewelry sales at León Gallery. Discover and acquire exceptional fine art through our exclusive private sale offerings. Enquire today.`,
    lotNo: '',
    canonical: `${GetURL}/sale?data=PAINTING`,
    url: `${GetURL}/sale?data=PAINTING`,
    imagUrl: `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
  };

  await fetch(`${GetURL}/meta`, {
    method: "POST",
    body: JSON.stringify(dataSend),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())

    .then((data) => {
      console.log("data send here ", data);
    })
    .catch((error) => {
      // alert.error(error)
      console.log("error ", error);
    });
  return (window.location.href = `/private/sale?data=${data}`);
}

export function handlePrivateARTS(data) {
  return (window.location.href = `/private/sale?data=${data}`);
}

export async function handlePrivateBOOKS(data) {

  const dataSend = {
    title: `Private Books Sales - Buy Fine Art | León Gallery Philippines `,
    discription: `Explore private Books sales at León Gallery. Discover and acquire exceptional fine art through our exclusive private sale offerings. Enquire today.`,
    lotNo: '',
    canonical: `${GetURL}/sale?data=PAINTING`,
    url: `${GetURL}/sale?data=PAINTING`,
    imagUrl: `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
  };

  await fetch(`${GetURL}/meta`, {
    method: "POST",
    body: JSON.stringify(dataSend),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())

    .then((data) => {
      console.log("data send here ", data);
    })
    .catch((error) => {
      // alert.error(error)
      console.log("error ", error);
    });

  return (window.location.href = `/private/sale?data=${data}`);
}

export async function handlePrivateSCULPTURE(data) {

  const dataSend = {
    title: `Private Scuplture Sales - Buy Fine Art | León Gallery Philippines `,
    discription: `Explore private Scuplture sales at León Gallery. Discover and acquire exceptional fine art through our exclusive private sale offerings. Enquire today.`,
    lotNo: '',
    canonical: `${GetURL}/sale?data=PAINTING`,
    url: `${GetURL}/sale?data=PAINTING`,
    imagUrl: `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
  };

  await fetch(`${GetURL}/meta`, {
    method: "POST",
    body: JSON.stringify(dataSend),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())

    .then((data) => {
      console.log("data send here ", data);
    })
    .catch((error) => {
      // alert.error(error)
      console.log("error ", error);
    });

  return (window.location.href = `/private/sale?data=${data}`);
}

export async function handleMain(data) {

  const dataSend = {
    title: `Leon Gallery Main Location | Philippine Art Gallery in Manila`,
    discription: `Visit the Main location of Leon Gallery in Manila, home to the finest collection of Philippine art. Explore our exhibitions, auctions, and exclusive collections of Filipino masterpieces.`,
    lotNo: '',
    canonical: `${GetURL}/sale?data=PAINTING`,
    url: `${GetURL}/sale?data=PAINTING`,
    imagUrl: `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
  };

  await fetch(`${GetURL}/meta`, {
    method: "POST",
    body: JSON.stringify(dataSend),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())

    .then((data) => {
      console.log("data send here ", data);
    })
    .catch((error) => {
      // alert.error(error)
      console.log("error ", error);
    });

  return (window.location.href = `/location/main?data=${data}`);
}

export async function handleInternational(data) {
  const dataSend = {
    title: `Leon Gallery International Location | Philippine Art Gallery in Manila`,
    discription: `Visit the International location of Leon Gallery in Manila, home to the finest collection of Philippine art. Explore our exhibitions, auctions, and exclusive collections of Filipino masterpieces.`,
    lotNo: '',
    canonical: `${GetURL}/sale?data=PAINTING`,
    url: `${GetURL}/sale?data=PAINTING`,
    imagUrl: `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
  };

  await fetch(`${GetURL}/meta`, {
    method: "POST",
    body: JSON.stringify(dataSend),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())

    .then((data) => {
      console.log("data send here ", data);
    })
    .catch((error) => {
      // alert.error(error)
      console.log("error ", error);
    });
  return (window.location.href = `/location/international?data=${data}`);
}

export async function handleLafuerza(data) {
  const dataSend = {
    title: `Leon Gallery La Fuerza Location | Philippine Art Gallery in Manila`,
    discription: `Visit the La Fuerza location of Leon Gallery in Manila, home to the finest collection of Philippine art. Explore our exhibitions, auctions, and exclusive collections of Filipino masterpieces.`,
    lotNo: '',
    canonical: `${GetURL}/sale?data=PAINTING`,
    url: `${GetURL}/sale?data=PAINTING`,
    imagUrl: `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
  };

  await fetch(`${GetURL}/meta`, {
    method: "POST",
    body: JSON.stringify(dataSend),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())

    .then((data) => {
      console.log("data send here ", data);
    })
    .catch((error) => {
      // alert.error(error)
      console.log("error ", error);
    });
  return (window.location.href = `/location/lafuerza?data=${data}`);
}

// export function handleMaison(data) {
//   return (window.location.href = `/location/maison?data=${data}`);
// }

export function handleClickStories() {
  return (window.location.href = `/stories`);
}


export async function handleExhibition() {
  localStorage.removeItem("@imageSingle");
  const dataSend = {
    title: 'Current & Past Art Exhibitions | Leon Gallery Manila',
    discription: 'Explore Leon Gallery’s curated art exhibitions in Manila, featuring renowned Filipino artists and historic collections. View current, upcoming, and past shows.',
    lotNo: '',
    canonical: `${GetURL}/exhibition`,
    url: `${GetURL}/exhibition`,
    imagUrl: `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
  };

  await fetch(`${GetURL}/meta`, {
    method: "POST",
    body: JSON.stringify(dataSend),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())

    .then((data) => {
      console.log("data send here ", data);
    })
    .catch((error) => {
      // alert.error(error)
      console.log("error ", error);
    });
  return (window.location.href = `/exhibition`);
}


export function handleClickLive() {

  return (window.location.href = `/auctions/room`);
  // return (window.location.href = `/live`);
}

